import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 px-4 md:px-6 bg-background-200/70">
      <div className="max-w-screen-2xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">专题聚焦</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            深度专题策划，带你从不同角度发现好剧好电影
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, index) => (
            <div
              key={item.id}
              className="group relative rounded-xl overflow-hidden bg-background-50 cursor-pointer"
              style={{ animation: `fadeInUp 0.5s ease-out ${index * 0.08}s both` }}
            >
              <div className="relative aspect-[8/5] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-md bg-accent-500 text-white text-xs font-semibold whitespace-nowrap">
                    {item.label}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white/80 text-xs mb-1">{item.subtitle}</p>
                  <h3 className="font-heading text-lg md:text-xl text-white">{item.title}</h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}